// Copyright 2020 Sorama B.V.

import { autoinject, bindable, customElement } from "aurelia-framework";
import { IGuidanceTopic } from "catalogs/GuidanceCatalog";
import { HelpWorkflowModuleCatalog } from "catalogs/WorkflowModuleCatalog/HelpWorkflowModuleCatalog";
import { TeaserQuestions } from "guidance/TeaserQuestions";
import { SidebarRouter } from "libraries/WorkflowFramework/Sidebar/SidebarRouter";
import { ShellViewManager } from "modules/shell/App/ShellViewManager";

@autoinject()
@customElement("progress-overlay")
export class ProgressOverlay {
    /**
     * Progress in percentage
     */
    @bindable
    public progress: number;

    @bindable
    public loading: boolean;

    @bindable
    public message: string;

    public question: string;
    public topic: IGuidanceTopic | URL;

    constructor(private readonly shellviewManager: ShellViewManager) {}

    public bind(): void {
        const result = TeaserQuestions.questions[Math.floor(Math.random() * TeaserQuestions.questions.length)];
        this.question = result.question;
        this.topic = result.topic;
    }

    public openTopic(): void {
        if (this.topic instanceof URL) {
            const win = window.open(this.topic.href, "_blank");
            win.focus();
            return;
        }

        this.shellviewManager.openRightSideBar(HelpWorkflowModuleCatalog.HelpModule, [
            {
                prefix: SidebarRouter.prefix,
                name: "topicName",
                value: this.topic.name,
            },
        ]);
    }
}
